"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpoint = void 0;
const micro_streaming = __importStar(require("@journeyapps-platform/micro-streaming"));
const defs = __importStar(require("../definitions"));
const definitions_1 = require("../definitions");
const utils = __importStar(require("../utils"));
const createEndpoint = (options) => {
    const request = async (payload, override) => {
        let request_options;
        if (typeof options === 'function') {
            request_options = options(payload);
        }
        else {
            request_options = options;
        }
        let method = request_options.method || defs.METHOD.POST;
        let body = request_options.payload || payload;
        /*
          In some cases we want the payload so we can dynamically construct a GET URL (`options` is a function),
          but don't want it automatically added to the body of the GET request
         */
        if (method === definitions_1.METHOD.GET) {
            body = null;
        }
        return await request_options.client.request(utils.join(request_options.endpoint, request_options.path), {
            method,
            ...request_options,
            body,
            ...(override || {})
        });
    };
    const defaultRequestFunction = async (params, override) => {
        const res = await request(params, override);
        return res.decode();
    };
    const streamedRequestFunction = async (params, override) => {
        const res = await request(params, override);
        const decode = async () => {
            const stream = await res.stream();
            return stream.pipeThrough(micro_streaming.bson.createBSONStreamDecoder());
        };
        return {
            response: res.response,
            stream: res.stream,
            decode: decode,
            [Symbol.asyncIterator]: async function* () {
                yield* micro_streaming.iterableFromReadable(await decode());
            }
        };
    };
    return Object.assign(defaultRequestFunction, {
        streamed: Object.assign(streamedRequestFunction, {
            request: request
        }),
        request: request
    });
};
exports.createEndpoint = createEndpoint;
